// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimelineEvent  {
    _originalTypeClassName = "Loom.BO.TimelineEvent";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimelineEvent.translate = translateService;
}
this.start = null;
this.end = null;
this.resourceId = null;
this.title = null;
this.TimelineEventKey = null;
this._key = this.TimelineEventKey = 0; 
}

static translate: TranslateService;
_key: any;
start:any;
end:any;
resourceId:any;
title:any;
extendedProps:any;
private _TimelineEventKey:any;
get TimelineEventKey(): any {
    return this._TimelineEventKey;
  }
set TimelineEventKey(value: any) {
    this._TimelineEventKey = value;
    this._key = value;
  }
static setextendedProps = ($this, value) => {
var oldValue = $this.extendedProps;
$this.extendedProps = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TimelineEventKey == null || $this.TimelineEventKey == 0;
            }


}